// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"74b9f6a3798bc4d12cea","655":"74ac90e921d61259fd35"}[chunkId] + ".js";
};